import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DynamicPage} from "../modules/dynamic-pages/DynamicPage";
import {useApplicationConfig} from "../modules/application-configuration/core/ApplicationConfiguration";
import {MenuEntry} from "../modules/application-configuration/core/_models";
import slugify from "../helpers/utils/slugify";
import {PageTitle} from "../../_metronic/layout/core";
import * as React from "react";

const DefaultDashboardPage = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
        </>
    )
}

const DynamicBuilderRoute = () => {
    const {menu} = useApplicationConfig()

    const buildRoutes = (menuItem: MenuEntry, prefix?: string, parents: MenuEntry[] = []): React.ReactElement[] => {
        const slug = (prefix != null ? prefix + '/' : '') + [menuItem.id, slugify(menuItem.title)].join('-');
        const url = 'page/' + slug;

        if (menuItem.items !== undefined && menuItem.items.length !== 0) {
            const children = menuItem.items.map(item => buildRoutes(item, slug, [...parents, menuItem]))

            return children.flat()
        }

        const breadcrumbs = [];

        if (parents.length) {
            for (const parent of parents) {
                breadcrumbs.push(...[
                    {
                        title: parent.title,
                        path: '',
                        isSeparator: false,
                        isActive: false,
                    },
                    {
                        title: '',
                        path: '',
                        isSeparator: true,
                        isActive: false,
                    }
                ])
            }
        }

        return [
            <Route
                key={'route-' + menuItem.num + menuItem.title}
                path={url}
                element={
                    <>
                        <PageTitle breadcrumbs={breadcrumbs}>{menuItem.title}</PageTitle>
                        <DynamicPage/>
                    </>
                }
            />
        ]
    }

    let dashboardLink = null;

    if (menu) {
        const dashboardItems = menu.items.filter((menuItem) => menuItem.title === 'Dashboard');

        if (dashboardItems.length > 0) {
            const dashboardMenuItem = dashboardItems[0];
            dashboardLink = '/page/' + [dashboardMenuItem.id, slugify(dashboardMenuItem.title)].join('-');
        }
    }

    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/dashboard'/>}/>
                {/* Pages */}
                {!dashboardLink && <Route path='dashboard' element={<DefaultDashboardPage/>}/>}
                {dashboardLink && <Route path='dashboard' element={<Navigate to={dashboardLink}/>}/>}
                {menu?.items.map(item => buildRoutes(item))}
                {/*<Route path='page/*' element={<DynamicPage/>}/>*/}
                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
}

/*const SuspensedView: FC<WithChildren> = ({children}) => {
    const baseColor = getCSSVariableValue('--kt-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}*/

export {DynamicBuilderRoute}
